import React from 'react';
import './InvestmentHelp.css';

const InvestmentHelp: React.FC = () => {
  return (
    <div className="investment-help module-name">
      <div className="page-header">
        <div>
          <h1>Help - Investimentos</h1>
          <p>Guia passo a passo para usar cada ferramenta de investimentos.</p>
        </div>
      </div>

      <div className="module-content">
        <div className="help-section">
          <h3>Plano de Investimentos</h3>
          <ol>
            <li>Abra "Plano" no menu Investimentos.</li>
            <li>Clique em "Novo plano" para abrir o formulário.</li>
            <li>Preencha idade atual, idade de retirada e expectativa de vida.</li>
            <li>Informe patrimônio inicial, retirada mensal planejada e contribuição mensal.</li>
            <li>Defina retorno nominal anual e inflação anual.</li>
            <li>Salve o plano e use a tabela para gerar projeções.</li>
            <li>Em "Gerar plano", confira o gráfico, o resumo anual e o alerta de esgotamento.</li>
          </ol>
          <div className="help-example">
            <strong>Exemplo:</strong> 30 anos, retirada aos 60, patrimônio inicial R$ 50.000,
            contribuição R$ 1.500, retorno 8% a.a., inflação 4% a.a.
          </div>
        </div>

        <div className="help-section">
          <h3>Tracking de Investimentos</h3>
          <ol>
            <li>Abra "Tracking" e crie um ledger com mês inicial e moeda.</li>
            <li>Selecione o ledger na lista.</li>
            <li>Registre o mês de referência, saldo inicial, contribuições, retiradas e saldo final.</li>
            <li>Opcionalmente, informe inflação anual para indicadores reais.</li>
            <li>Clique em "Atualizar indicadores" para ver retornos, CAGR e drawdown.</li>
          </ol>
          <div className="help-example">
            <strong>Exemplo:</strong> Ledger "Carteira 2026", janeiro 2026 com saldo inicial
            R$ 60.000, contribuições R$ 1.500, retiradas R$ 0, saldo final R$ 62.100.
          </div>
        </div>

        <div className="help-section">
          <h3>Cenários</h3>
          <ol>
            <li>Abra "Cenários" e selecione um plano base.</li>
            <li>Crie cenários ajustando retorno, inflação e idade de aposentadoria.</li>
            <li>Use "Comparar cenários" para visualizar resultados lado a lado.</li>
          </ol>
          <div className="help-example">
            <strong>Exemplo:</strong> Cenário otimista com +2% no retorno e -1% na inflação.
          </div>
        </div>

        <div className="help-section">
          <h3>Alocação de Ativos</h3>
          <ol>
            <li>Abra "Alocação" e informe perfil de risco.</li>
            <li>Liste classes de ativos e defina alocação alvo e atual.</li>
            <li>Salve e verifique alertas de rebalanceamento.</li>
          </ol>
          <div className="help-example">
            <strong>Exemplo:</strong> Alvo: Ações 60%, Renda Fixa 40%. Atual: Ações 52%, Renda Fixa 48%.
          </div>
        </div>

        <div className="help-section">
          <h3>Metas e Independência Financeira</h3>
          <ol>
            <li>Abra "Metas" e crie objetivos com valor e data.</li>
            <li>Selecione um plano relacionado quando necessário.</li>
            <li>Preencha gastos anuais e taxa de retirada para calcular indicadores FI.</li>
          </ol>
          <div className="help-example">
            <strong>Exemplo:</strong> Meta "Aposentadoria" de R$ 1.200.000 até 2045. FI com
            gasto anual R$ 60.000 e taxa de retirada 4%.
          </div>
        </div>

      </div>
    </div>
  );
};

export default InvestmentHelp;
